const initialState = {
    selected_products: [],
    isAddQuotesModalOpen: false,
    isAddProductsModalOpen: false
};

export default initialState;
